import * as React from 'react';
import AirbnbLoginForm from '../../../../containers/AirbnbLoginForm';

export default class AirbnbLogin extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <AirbnbLoginForm />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConnectListings/ConnectAirbnb/AirbnbLogin/AirbnbLogin.tsx